export enum UserRole {
    BITS_USER = 'BITS_USER',
    KUP_USER = 'KUP_USER',
    KUP_ADMIN = 'KUP_ADMIN',
    KUP_BIOMATERIAL_REQUEST_USER = 'KUP_BIOMATERIAL_REQUEST_USER',
    KUP_GENOTYPE_REGISTRY_ADMIN = 'KUP_GENOTYPE_REGISTRY_ADMIN'

}
